import SwipeableFormDrawer from "components/SwipeableFormDrawer";
import ReportTechnicalIssueForm from "./form";

export default function ReportTechnicalIssue() {
    return (
        <SwipeableFormDrawer>
            <ReportTechnicalIssueForm />
        </SwipeableFormDrawer>
    )
}